<template>

    <v-toolbar color="#EFEFEF" :flat="true" fixed app>

        <v-toolbar-side-icon class="menu-icon" @click.stop="handleDrawerToggle"></v-toolbar-side-icon>

        <v-flex column>
            <v-toolbar-title class="ml-0">
                <div>{{viewTitle}}</div>
                <!--<div class="small-subtitle highlight hidden-sm-and-up">{{selectedAccounting.customerName}}</div>-->
            </v-toolbar-title>
            <v-menu offset-y origin="top center" :nudge-bottom="5" transition="scale-transition"
                    v-if="multiStore" :disabled="!canSelectStore">
                <v-btn slot="activator" flat small round v-if="canSelectStore"
                       style="padding: 0 3px; margin-left: -2px; margin-top: -1px;  height: 20px !important;">
                    <div class="small-subtitle">{{selectedStore}}
                        <v-icon class="mx-2 mr-0 fas fa-chevron-down" size="13"></v-icon>
                    </div>
                </v-btn>
                <div v-else slot="activator" class="small-subtitle">{{selectedStore}}</div>
                <v-list class="pa-0">
                    <v-subheader v-t="'appMsg.storeSelection'"></v-subheader>
                    <v-list-tile v-for="(store,index) in allStores"
                                 @click="onChangeStoreClick(store)" ripple="ripple" :key="index">
                        <v-list-tile-content>
                            <v-list-tile-title
                                    :class="{'primary--text font-weight-bold': store.name === selectedStore }">
                                {{store.name}}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-flex>

        <!--<v-text-field
                flat
                solo-inverted
                prepend-icon="search"
                label="Search"
                class="hidden-sm-and-down"
        >
        </v-text-field>-->

        <v-spacer></v-spacer>

        <!--SELECTOR -->
        <template v-if="config.toolbarSelector">
            <v-divider class="ml-2" vertical inset></v-divider>
            <v-menu offset-y origin="top right" nudge-bottom="4" nudge-left="70" transition="scale-transition">
                <v-layout slot="activator">
                    <v-btn class="hidden-sm-and-down" round large flat
                           style="padding-right: 9px; padding-left: 9px;">
                        <!--<v-icon class="mx-2 pr-2 fas fa-book" size="28"></v-icon>-->
                        <v-flex vertical class="pl-2">
                            <span>{{selectedAccounting.customerName}}</span>
                            <div class="small-subtitle" style="text-transform: capitalize">
                                {{selectedAccounting.lastDate}}
                            </div>
                        </v-flex>
                        <v-divider class="ml-2" vertical inset
                                   style="background-color: rgba(255,255,255,0.4);"></v-divider>

                        <v-icon class="mx-2 pl-1 fas fa-chevron-down" size="15"></v-icon>
                    </v-btn>
                </v-layout>
                <notification-list :notifications="notifications"></notification-list>
            </v-menu>

        </template>


        <!--<v-divider class="ml-2 hidden-sm-and-up" vertical inset></v-divider>-->

        <!--PAGE WHATSAPP BUTTON HOMEOFFICE CONFIANCA-->
        <v-scale-transition v-if="companyBrand.id == 8" origin="center center 0">
            <v-btn icon outline @click="onWhatsappClick">
                <v-icon small>fa-whatsapp</v-icon>
            </v-btn>
        </v-scale-transition>

        <!--PAGE FILTERING BUTTON-->
        <v-scale-transition origin="center center 0">
            <v-btn icon v-if="$route.meta.filterComponent" outline @click="onFilterClick">
                <v-icon small>fa-filter</v-icon>
            </v-btn>
        </v-scale-transition>

        <!--FAVORITE BUTTON-->
        <v-menu v-if="config.favorites" offset-y origin="top right" nudge-bottom="14" offset-x left nudge-right="70"
                transition="scale-transition">
            <v-btn icon flat slot="activator">
                <v-icon style="padding-bottom: 2px;">fas fa-star</v-icon>
            </v-btn>
            <v-list class="pa-0">
                <v-subheader v-t="'appMsg.quickAccess'"></v-subheader>
                <v-list-tile v-for="(item,index) in favorites"
                             :to="item.routeName ? { name: item.routeName } : null"
                             ripple="ripple" :key="index">

                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>

        <!--NOTIFICATIONS BUTTON-->
        <v-menu offset-y origin="top right" :nudge-bottom="14" offset-x left nudge-right="45"
                transition="scale-transition">
            <v-btn icon flat slot="activator">
                <v-badge color="red" overlap :class="{tadaNow: animate.badge}">
                    <span slot="badge" v-if="notificationsQty">{{notificationsQty}}</span>
                    <v-icon style="font-size: 31px; padding-top: 2px">notifications</v-icon>
                </v-badge>
            </v-btn>
            <notification-list :notifications="userNotifications"></notification-list>
        </v-menu>

        <!--USER BUTTON-->
        <v-menu offset-y origin="top right" :nudge-bottom="10" offset-x left nudge-right="70"
                transition="scale-transition">
            <v-btn icon large flat slot="activator">
                <v-avatar size="38px">
                    <span v-if="!userAvatar" class="flaticon-user-avatar fsi-28"></span>
                    <img v-else :src="userAvatar" :alt="userName"/>
                </v-avatar>
            </v-btn>
            <v-list class="pa-0">
                <v-subheader> {{ userName }}</v-subheader>
                <v-list-tile v-for="(item,index) in userOptions"
                             :to="item.routeName ? { name: item.routeName } : null"
                             @click="item.click" ripple="ripple" :disabled="item.disabled"
                             rel="noopener" :key="index*100">
                    <v-list-tile-action v-if="item.icon">
                        <v-icon :class="item.icon">{{ item.icon }}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>

        <!--FULL SCREEN BUTTON-->
        <v-btn icon @click="$util.toggleFullScreen" class="hidden-sm-and-down">
            <v-icon style="font-size: 34px">fullscreen</v-icon>
        </v-btn>

    </v-toolbar>

</template>

<script>
   import NotificationList from './NotificationList';

   export default {
      name: 'app-toolbar',
      components: {
         NotificationList
      },

      props: {
         config: {
            type: Object,
            required: false
         }
      },

      data() {
         return {
            animate: {
               badge: false,
               filter: false
            },
            userOptions: [
               /*{
                  icon: 'account_circle',
                  title: this.$t('appMsg.myProfile'),
                  routeName: '',
                  click: (e) => {
                     console.log(e);
                  }
               },*/
               {
                  icon: 'flaticon-access-key',
                  title: this.$t('appMsg.changePin'),
                  routeName: 'ChangePin',
                  click: (e) => {
                     console.log(e);
                  }
               },
               {
                  icon: 'fas fa-sign-out-alt',
                  title: this.$t('appMsg.logout'),
                  routeName: '',
                  click: (e) => {
                     window.getApp.$emit('APP_LOGOUT');
                  }
               }
            ],
            favorites: []
         }
      },


      computed: {
         userAvatar() {
            let avatar = this.$store.state.company.user.avatar;
            let media;
            if (avatar) {
                media = this.$config.imageUri(avatar, 'avatar')
            }

            return media;
         },
         userName() {
            return this.$store.state.company.user.name;
         },
         userNotifications() {
            if (this.$store.state.company.user.notifications && this.$store.state.company.user.notifications.length) {
               setTimeout(() => this.animate.badge = true, 1200);
               setTimeout(() => this.animate.badge = false, 1800);
            }
            return this.$store.state.company.user.notifications;
         },
         viewTitle() {
            let routeTitle = (this.$route && this.$route.meta) ? this.$route.meta.title : this.$route.name;
            let title = this.$store.state.app.viewTitle || routeTitle;
            return (title && title.match(/[.]/g)) ? this.$t(title) : title;
         },
         multiStore() {
            return this.$store.state.company.multiStore;
         },
         allStores() {
            return this.$store.state.company.brandStores || [];
         },
         selectedStore() {
            return this.$store.state.company.selectedStoreName;
         },
         canSelectStore() {
            return this.$store.state.company.brandStores.length > 1
         },
         selectedAccounting() {
            return {customerName: 'My Company Books', lastDate: 'March 31, 2018'};
         },
         notificationsQty() {
            return (this.$store.state.company.user.notifications) ? this.$store.state.company.user.notifications.length : 2; //demo qty
         },
         companyBrand () {
            return this.$store.state.company.brand;
         },
      },


      methods: {
         handleDrawerToggle() {
            window.getApp.$emit('APP_DRAWER_TOGGLED');
         },
         onWhatsappClick() {
            window.open("https://api.whatsapp.com/send/?phone=558431132323", "_blank");
         },
         onFilterClick() {
            window.getApp.$emit('APP_RIGHT_DRAWER_TOGGLED', this.$route.meta.filterComponent);
         },
         onChangeStoreClick(store) {
            this.$store.dispatch('company/stSelectCompany', store);
         }
      },


      created() {
         window.getApp.$on('APP_NOTIFICATIONS', (data) => {
            // console.log(data);
            if (!this.notifications)
               this.notifications = data;
            else
               this.notifications.push(...data);
         });


         // setInterval(() => window.getApp.$emit('APP_NOTIFICATIONS', [1,3,4]), 5000);
      },

      mounted() {
         this.$router.options.routes.forEach(r => {
            if (r.meta && r.meta.quickAccess)
               this.favorites.push({title: r.meta.title, routeName: r.name});
         })
      }

   };
</script>

<style lang="css">
    .v-toolbar__extension {
        padding: 0;
    }

    .menu-icon {
        min-width: 36px;
        margin-left: -10px !important;
        margin-right: 15px !important;
    }

    .small-subtitle {
        font-size: 12px;
        font-style: italic;
        color: aliceblue;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: uppercase;
    }

    .highlight {
        color: yellow !important;
    }

    .fsi-28::before {
        font-size: 28px !important;
    }

    .tadaNow {
        animation-name: tada;
        animation-duration: 0.5s;
        animation-fill-mode: forwards;
    }

    animateNow {
        animation-duration: 0.4s;
        animation-fill-mode: forwards;
    }


</style>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/components/AppToolbar.vue